import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Stack,
  Fab,
  Divider,
  Card,
  CardContent,
} from "@mui/material";
import { ReceiptLong, Receipt, QrCodeScanner } from "@mui/icons-material";
import { useAuth } from "../../../hooks/auth";
import api from "../../../services/api";

export const ScanTicket = () => {
  const navigate = useNavigate();
  const { cookies } = useAuth();
  const [transactions, setTransactions] = useState([]);

  const transactionList = (transactions) => {
    // const transactionArray = transactions.reverse();
    // console.log(transactionArray.length)
    const list = transactions
      .slice(0)
      .reverse()
      .map((value, index) => {
        const date_time = new Date(value.createdAt);
        const year = date_time.getFullYear();
        const month = date_time.getMonth() + 1;
        const day = date_time.getDate();
        const hours = date_time.getHours();
        const minutes = date_time.getMinutes();
        const seconds = date_time.getSeconds();
        return (
          <Card
            key={index}
            sx={{
              minWidth: 325,
              maxWidth: 600,
              boxShadow: "2px 2px 9px -4px rgba(0,0,0,0.75)",
            }}
          >
            <CardContent>
              <Stack spacing={1}>
                <Box
                  sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>{`${day}-${month}-${year} ${hours}:${minutes}:${seconds}`}</Typography>
                  <Typography>{value.meal_type}</Typography>
                </Box>
                <Divider />
                <Typography component="div">{value.food_name}</Typography>
                <Typography color="text.secondary">
                  Student: {value.student}
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        );
      });
    return (
      <Stack px="15px" pt="10px" spacing={2}>
        {list}
      </Stack>
    );
  };

  const nil_transactions = () => {
    return (
      <Stack spacing={2}>
        <Receipt sx={{ fontSize: "100px", margin: "auto" }} />
        <Typography variant="subtitle2">
          No transaction has been recorded.
          <br />
          Proceed to scan a meal ticket.
        </Typography>
      </Stack>
    );
  };

  const getTransactions = async () => {
    try {
      const response = await api.get("/transactions", {
        headers: {
          Authorization: `Bearer ${cookies.data.token}`,
        },
        params: { attendant: cookies.attendant.fullname }, // Use the params variable directly without an object wrapper
      });
      setTransactions(response.data.data);
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTransactions();
  }, []);

  const openQrScanner = () => {
    navigate("/qr-scan");
  };

  return (
    <Box>
      <AppBar position="sticky">
        <Toolbar disableGutters={true}>
          <Stack
            direction="row"
            sx={{
              display: "flex",
              alignItems: "center",
              color: "white",
            }}
          >
            <ReceiptLong
              sx={{ margin: "5px", marginLeft: "10px", marginRight: "10px" }}
            />
            <Typography variant="h5">Transaction History</Typography>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          color: "rgba(48, 54, 70, 0.3)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          position: "absolute",
          top: "40%",
        }}
      >
        {(transactions.length > 0) ? transactionList(transactions) : nil_transactions()}
      </Box>
      <Fab
        color="primary"
        aria-label="scan digital ticket"
        sx={{
          color: "white",
          position: "absolute",
          bottom: "20px",
          right: "20px",
        }}
        onClick={openQrScanner}
      >
        <QrCodeScanner sx={{ fontSize: "29px" }} />
      </Fab>
    </Box>
  );
};
